import { MutableRefObject, useEffect, useRef, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { ReactState, StateSetter } from '../../React/Common/Types/Types'
import { Page } from '../../NonReact/constants/Components/Page'
import { getPageName } from '../../NonReact/common/DataIngest'

const MAX_RETRIES: number = 1000

export const useCurrentPage = (): Definable<Page> => {
    const [pageName, setPageName]: ReactState<Page> = useState<Page>(Page.WELCOME)
    const numberOfRetries: MutableRefObject<number> = useRef(0)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    const initialise = (setter: StateSetter<Page>): void => {
        if (isMounted.current) {
            const name: Page = getPageName()

            if (!name && numberOfRetries.current <= MAX_RETRIES) {
                numberOfRetries.current += 1
                setTimeout((): void => {
                    if (isMounted.current) {
                        initialise(setter)
                    }
                }, 100)
            } else {
                setter(name)
            }
        }
    }

    useEffect((): void => {
        initialise(setPageName)
    }, [])

    return pageName
}
